import { Grid } from "@material-ui/core"
import { IndicacaoRevendedoresHeader } from "./components/indicacao-revendedores-header/indicacao-revendedores-header"
import { IndicacaoRevendedoresList } from "./components/indicacao-revendedores-list/indicacao-revendedores-list"
import { ButtonFab } from "views/components/controles"
import { NovoIcon } from "views/components/icons"
import { useDefaultCadastroStyles } from "../cadastros/components/default-cadastro-styles"
import { useCadastros } from "services/app"
import { useState } from "react"
import { IndicacaoRevendedoresListSearchProps } from "./components/indicacao-revendedores-list/indicacao-revendedores-list-search-props"

export const IndicacaoRevendedoresPage = () => {

    const cadastroClasses = useDefaultCadastroStyles();
    const { abrirCadastroIndicacaoRevendedor } = useCadastros()
    const [searchProps, setSearchProps] = useState<IndicacaoRevendedoresListSearchProps>({
        termo: ''
    })

    return (
        <Grid className={cadastroClasses.root}>
            <Grid className={cadastroClasses.header}>
                <IndicacaoRevendedoresHeader
                    setSearchProps={setSearchProps}
                />
            </Grid>
            <Grid className={cadastroClasses.list}>
                <IndicacaoRevendedoresList searchProps={searchProps} />
            </Grid>
            <ButtonFab
                tooltip="Nova Indicação"
                icon={<NovoIcon tipo="BUTTON_FAB" />}
                onClick={() => abrirCadastroIndicacaoRevendedor(undefined, '', true)}
            />
        </Grid>
    )
}